"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.gstStatementQuerySchema = exports.GST_STATEMENT_MAX_DAYS = void 0;
const zod_1 = require("zod");
/** `YYYY-MM-DD` — a calendar day, not an instant. */
const dayString = zod_1.z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'Use YYYY-MM-DD.');
/** The longest period one statement covers: a financial year plus a margin. Beyond it the monthly working stops meaning anything. */
exports.GST_STATEMENT_MAX_DAYS = 400;
/** `Date.parse` rolls 2026-02-30 over to 2 March; Postgres refuses it. A day is real only if it survives the round trip. */
function isRealDay(day) {
    const parsed = Date.parse(`${day}T00:00:00Z`);
    return !Number.isNaN(parsed) && new Date(parsed).toISOString().slice(0, 10) === day;
}
function daysBetween(from, to) {
    return Math.round((Date.parse(`${to}T00:00:00Z`) - Date.parse(`${from}T00:00:00Z`)) / 86_400_000);
}
/**
 * `GET /financial/gst-statement` and `/financial/gst-statement/export`.
 *
 * `openingCredit` is the input-tax credit the hospital already holds at the START of the period (paise) — read off the GST portal's credit ledger by the
 * accountant; the system cannot know credit from before it carried GST. Default 0.
 */
exports.gstStatementQuerySchema = zod_1.z
    .object({
    from: dayString,
    to: dayString,
    openingCredit: zod_1.z.coerce.number().int().min(0).max(100_000_000_000).optional(),
})
    .superRefine((value, ctx) => {
    const realFrom = isRealDay(value.from);
    const realTo = isRealDay(value.to);
    if (!realFrom)
        ctx.addIssue({ code: zod_1.z.ZodIssueCode.custom, message: 'Not a valid date.', path: ['from'] });
    if (!realTo)
        ctx.addIssue({ code: zod_1.z.ZodIssueCode.custom, message: 'Not a valid date.', path: ['to'] });
    if (!realFrom || !realTo)
        return;
    const days = daysBetween(value.from, value.to);
    if (days < 0)
        ctx.addIssue({ code: zod_1.z.ZodIssueCode.custom, message: 'The period must not end before it starts.', path: ['to'] });
    if (days > exports.GST_STATEMENT_MAX_DAYS) {
        ctx.addIssue({ code: zod_1.z.ZodIssueCode.custom, message: `A statement covers at most ${exports.GST_STATEMENT_MAX_DAYS} days.`, path: ['to'] });
    }
});
//# sourceMappingURL=gst-statement.schema.js.map